{
  "home": {
    "title": "Home",
    "menu": {
      "sidebar": {
        "label": "Home"
      },
      "tabBar": {
        "label": "Home"
      }
    }
  },
  "chat": {
    "title": "Chat",
    "menu": {
      "sidebar": {
        "label": "Chat"
      },
      "tabBar": {
        "label": "Chat"
      }
    }
  },
  "workouts": {
    "title": "Workouts",
    "menu": {
      "sidebar": {
        "label": "Workouts"
      },
      "tabBar": {
        "label": "Workouts"
      }
    }
  },
  "meals": {
    "title": "Meals",
    "menu": {
      "sidebar": {
        "label": "Meals"
      },
      "tabBar": {
        "label": "Meals"
      }
    }
  },
  "profile": {
    "title": "Profile",
    "menu": {
      "sidebar": {
        "label": "Profile"
      },
      "tabBar": {
        "label": "Profile"
      }
    }
  },
  "logout": "Log out",
  "menu": "Menu",
  "userMenu": {
    "title": "Menu",
    "settings": "Settings",
    "billing": "Billing"
  }
}
